<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="flex flex-col">
        <div class="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 justify-start m-2">
          <div class="action-buttons md:order-2 md:ml-auto flex items-center gap-2">
            @if (productId) {
              <fh-refresh-button [onRefresh]="refreshProduct" label="Reload product" />
            }
            <button
              mat-raised-button
              class="btn btn-danger flex gap-2"
              (click)="goBack()"
            >
              <mat-icon>arrow_back</mat-icon> Back
            </button>
          </div>
          <div class="flex flex-row flex-nowrap items-center gap-2 md:gap-4 md:order-1">
          @for (category of categories; track category) {
          <button
            mat-raised-button
            [disabled]="!!this.productId"
            type="button"
            class="btn !min-w-0 !px-2 !text-xs md:!px-4 md:!text-sm whitespace-nowrap"
            (click)="categoryId.set(category.id)"
            [ngClass]="{
              'btn-primary': activeSegment() === category.id,
              'btn-light': activeSegment() !== category.id,
              'btn-border': this.productId
            }"
          >
            {{ category.label }}
          </button>
          }
          </div>
        </div>
        @if (productId) {
        <p class="text-xs text-muted m-2">
          Category can't be changed for an existing product.
        </p>
        }
        <h4>{{getFormTitle()}}</h4>

        <div class="flex flex-col gap-4 justify-center">
          @if (activeSegment() === livestockSegment) {
          <fh-product-input
            formTitle="Product Input(Live Stock)"
            [controls]="livestockControls"
            [categoryId]="categoryId()"
            [productId]="productId!"
            (formIsValid)="productInput.valid.set($event)"
            (formChanged)="productInput.data.set($event)"
            (productCategorySegment)="getProductCategorySegment($event)"
          >
          </fh-product-input>
          } @else if (activeSegment() === tankSegment) {
          <fh-product-input
            formTitle="Product Input(Tank)"
            [controls]="tankInputControls"
            [categoryId]="categoryId()"
            [productId]="productId!"
            (formIsValid)="productInput.valid.set($event)"
            (formChanged)="productInput.data.set($event)"
            (productCategorySegment)="getProductCategorySegment($event)"
          >
          </fh-product-input>
          } @else {
          <fh-product-input
            formTitle="Product Input(Other)"
            [controls]="otherProductInputControls"
            [categoryId]="categoryId()"
            [productId]="productId!"
            (formIsValid)="productInput.valid.set($event)"
            (formChanged)="productInput.data.set($event)"
            (productCategorySegment)="getProductCategorySegment($event)"
          >
          </fh-product-input>
          }
        </div>

        <div class="flex flex-col gap-4 justify-center">
          @if (error) {
            <div class="alert alert-danger alert-dismissible fade show" role="alert">
              <h5>Please fix the following errors:</h5>
              <ul class="mb-0">
                <li>
                  <strong>Error:</strong> {{ error }}
                </li>
              </ul>
            </div>
          }

          @if (success) {
            <div class="alert alert-success alert-dismissible fade show" role="alert">
              {{ success }}
            </div>
          }

          @if (!productInput.valid()) {
          <p class="text-sm text-muted mb-0">
            Save is disabled until all required fields are complete — add at least one country with
            its pricing and variations, and upload at least one product image.
          </p>
          }

          <button
            mat-raised-button
            type="button"
            (click)="saveProduct()"
            [disabled]="!productInput.valid() || isSaving"
            class="btn btn-danger pull-right mt-20"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
